import { useVideoEditorDeleteEdits } from '@mi-front/api-v2';

/**
 * Deletes a video editor edit and triggers an optional success callback.
 */
export function useEditCardDelete(editId: string, onSuccess?: () => Promise<void> | void) {
  const deleteMutation = useVideoEditorDeleteEdits({
    mutation: {
      onSuccess: async () => {
        await onSuccess?.();
      },
    },
  });

  const handleDelete = async () => {
    await deleteMutation.mutateAsync({ id: editId });
  };

  return { handleDelete };
}
